$(document).ready(function () {
  $(document).on('click', '.add-to-cart-button', function (event) {
    event.preventDefault();
    if (!$(this).is('[disabled]')) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          id: parseInt($(this).data('product-key')),
          quantity: $(this).parents('.product-details').find('.quantity__input').val()
        },
        dataType: 'json',
        success: function(data) {
          console.log(data);
          $.ajax({
            url: window.location.href,
            success: function(response) {
            console.log(response)
  //             $('.cart-total-items').text(cart.item_count);
  //             $('.cart-total-items').attr('aria-hidden', 'false');
              $('.cart-items-details').replaceWith($(response).find('.cart-items-details'));
            }
          });
            
          swal({
            title: "Item is Added!",
            text: "item has been added to the cart successfully!",
            icon: "success",
          });
  
        }, error: function(xhr, textStatus, error) {
          toastr.info(xhr.responseJSON.description, {
            timeOut: 5000
          });
        }
      });
    }
  });  
});